<div class="modal-header">
    <button type="button" class="close" aria-label="Close" (click)="cancel()"><span aria-hidden="true">&times;</span></button>
    <h4 class="modal-title" id="labelButtons">Physical Attribute Details</h4>
</div>
<div class="modal-body">
    <validation-results [validationResults]="validationResults" *ngIf="showValidationComponent"></validation-results>
    <form [formGroup]="attributeForm">
        <fieldset>
            <div class="row">
                <div class="col-sm-4 col-md-3 mvd_form-group">
                    <label>Gender</label>
                    <select class="mvd_form-control" formControlName="genderTypeId">
                        <option *ngFor="let gender of customerGenderTypes" value="{{gender.id}}">{{gender.displayValue}}</option>
                    </select>
                </div>
                <div class="col-sm-4 col-md-3 mvd_form-group">
                    <label>Eye Color</label>
                    <select class="mvd_form-control" formControlName="eyeColorTypeId">
                        <option *ngFor="let eyeColor of customerEyeColorTypes" value="{{eyeColor.id}}">{{eyeColor.displayValue}}</option>
                    </select>
                </div>
                <div class="col-sm-4 col-md-3 mvd_form-group">
                    <label>Hair Color</label>
                    <select class="mvd_form-control" formControlName="hairColorTypeId">
                        <option *ngFor="let hairColor of customerHairColorTypes" value="{{hairColor.id}}">{{hairColor.displayValue}}</option>
                    </select>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-2 mvd_form-group">
                    <label>Height (FT)</label>
                    <select class="mvd_form-control" formControlName="heightFT">
                        <option value=""></option>
                        <option *ngFor="let foot of feet" [value]="foot">{{foot}}</option>
                    </select>
                </div>
                <div class="col-sm-2 mvd_form-group">
                    <label>Height (IN)</label>
                    <select class="mvd_form-control" formControlName="heightIN">
                        <option *ngFor="let inch of inches" [value]="inch">{{inch}}</option>
                    </select>
                </div>
                <div class="col-sm-2 mvd_form-group">
                    <label>Weight (LBS)</label>
                    <input class="mvd_form-control" type="text" autocomplete="off" formControlName="weight" />
                    <div class="mvd_alert__validation">
                        <div class="mvd_alert__rule" *ngIf="attributeForm.controls.weight.hasError('pattern')">Weight must be a numeric value</div>
                    </div>
                </div>
            </div>
        </fieldset>
    </form>
</div>
<div class="modal-footer">
    <div class="btn--group">
        <button class="btn--default" type="button" (click)="cancel()">Cancel</button>
        <mvm-spinner-btn [isDisabled]="!(attributeForm.valid && attributeForm.dirty)" [isLoading]="showButtonLoading" [btnText]="'Save'" (clicked)="saveAttribute()"></mvm-spinner-btn>
    </div>
</div>